module.exports = __webpack_public_path__ + "static/media/tableImageColors.1b091086.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/tableImageColors.svg
// module id = 1294
// module chunks = 0